import api from '../../REST/api';
import deriveLinkComponents from '../derive-link-components';
import PaymentTermsLabel from './PaymentTermsLabel';

const { Link } = deriveLinkComponents(PaymentTermsLabel, api.getPaymentTerm);

// eslint-disable-next-line import/prefer-default-export
export { Link as PaymentTermsLabel };
